export default {
    'log on':'登录',
    'forgot password':'忘记密码',
}
